import apiClient from '@u/apiClient'
import FetchMailboxMessagesFromDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Mailbox/FetchMailboxMessagesFromDossierController'

export default {
  fetchMailboxMessages({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchMailboxMessagesFromDossierController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
